<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { MagnifierIcon } from '@solar-icons/vue/linear'
import AppBadge from '../../primitives/AppBadge/AppBadge.vue'
import ActivitySourceRows from './ActivitySourceRows.vue'
import { searchQuery } from './activity-groups'
import { isFinished, type ActivityItem } from './activity-thread-types'

defineProps<{
  /** The searches of one group, each with its query and the results it returned. */
  searches: readonly ActivityItem[]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="flex min-w-0 flex-col gap-2">
    <div
      v-for="search in searches"
      :key="search.id"
      data-part="search"
      class="flex min-w-0 flex-col gap-1 rounded-4 bg-bg-well p-2 inset-shadow-well"
    >
      <div class="icon-sm flex min-w-0 items-center gap-4 px-4 py-2 text-body-sm-medium">
        <MagnifierIcon aria-hidden="true" class="shrink-0 text-icon-tertiary" />
        <span class="min-w-0 flex-1 truncate text-text-primary">{{
          searchQuery(search) ?? t('chat.activity.label.research.searchingWeb')
        }}</span>
        <AppBadge v-if="search.sources?.length">{{
          t('chat.activity.resultCount', { count: search.sources.length })
        }}</AppBadge>
      </div>
      <ActivitySourceRows v-if="search.sources?.length" :sources="search.sources" nested />
      <p v-else-if="!isFinished(search.status)" class="px-4 pb-2 text-caption text-text-tertiary">
        {{ t('chat.activity.searching') }}
      </p>
    </div>
  </div>
</template>
